import axios from "axios";
import store from "@/store";
import { LOGIN_SUCCESS, LOGIN_ERROR } from "./mutation-types";

const VUE_APP_COPRA_SERVER_URL = process.env.VUE_APP_COPRA_SERVER_URL;

const actions = {
  doLogin: ({ commit }, { email, password }) => {
    return new Promise((resolve, reject) => {
      axios.post(`${VUE_APP_COPRA_SERVER_URL}/auth`, { email, password })
        .then(response => {
          const { accountUid, accountName, userName, userRoles, userToken } = response.data;
          localStorage.setItem("accountUid", accountUid);
          localStorage.setItem("accountName", accountName);
          localStorage.setItem("userName", userName);
          localStorage.setItem("userEmail", email);
          localStorage.setItem("userRoles", userRoles);
          localStorage.setItem("userToken", userToken);

          commit(LOGIN_SUCCESS, { accountUid, accountName, userName, userEmail: email, userRoles, userToken });
          axios.defaults.headers.common['Authorization'] = store.getters.getAuth;
          resolve(response);
        })
        .catch(err => {
          commit(LOGIN_ERROR, err);
          localStorage.removeItem("accountUid");
          localStorage.removeItem("accountName");
          localStorage.removeItem("userName");
          localStorage.removeItem("userEmail");
          localStorage.removeItem("userRoles");
          localStorage.removeItem("userToken");
          reject(err);
        })
    })
  },
};

export default actions;